import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_cats: FaireCategoryEntity = {
  token: "catalog_cat_cats",
  type: "category",
  name: "Cats",
  count: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
